import { UploadIcon, XCircleIcon } from '@heroicons/react/solid';
import { useRef, useState } from 'react';

function ImageUploader({ name, current, fit = 'contain' }) {
    const input = useRef();
    const [preview, setPreview] = useState(current);

    const handleChange = (e) => {
        const newFile = e.target.files[0] ?? null;
        setPreview(newFile ? URL.createObjectURL(newFile) : null);
    };

    const handleClear = () => {
        input.current.value = null;
        setPreview(null);
    };

    return (
        <div className="relative inline-block h-full">
            <label className="flex items-center justify-center h-full max-h-full overflow-hidden bg-gray-200 border border-gray-300 rounded-sm cursor-pointer">
                <input ref={input} className="hidden" name={name} type="file" accept="image/*" onChange={handleChange} />
                {preview ? (
                    <img className={`block h-[140px] max-w-[300px] ${fit == 'contain' ? 'object-contain' : 'object-cover'}`} src={preview} />
                ) : (
                    <div className="grid h-[140px] w-[140px] place-items-center">
                        <UploadIcon className="w-6 h-6 text-gray-400" />
                    </div>
                )}
                {!preview && <input type="hidden" name={name} />}
            </label>
            {preview && <XCircleIcon className="absolute w-6 h-6 text-blue-600 bg-gray-100 rounded-full cursor-pointer -right-3 -top-3" onClick={handleClear} />}
        </div>
    );
}

export default ImageUploader;
